import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-multimedia-manager-downloads',
  templateUrl: './multimedia-manager-downloads.component.html',
  styleUrls: ['./multimedia-manager-downloads.component.scss']
})
export class MultimediaManagerDownloadsComponent implements OnInit {

  @Input() downloads;
  collapseDownloads: boolean;

  constructor() { }

  ngOnInit() {
  }

  public collapse() {
    this.collapseDownloads = !this.collapseDownloads;
  }
}
